import PicturesTable from "./PicturesTable.vue";
import setupTableComponents from "./table";

export default function (app) {
    setupTableComponents(app);
    app.component("T3PicturesTable", PicturesTable);
}
